import React, { useState, useEffect } from 'react';
import { Switch } from '@headlessui/react';

export const StepTwo = (props) => {

    const [data, setData] = useState({
        condition: props.data.condition,
        plate: props.data.plate,
        brand: props.data.brand,
        model: props.data.model,
        color: props.data.color,
        year: props.data.year,
        serial: props.data.serial,
        idParking: props.data.idParking,
        typeVehicle: props.data.typeVehicle,
    })

    const handleChange = (prop, value) => {
        if(prop === 'year') {
            if(isNaN(value)) {
                return;
            }
            if(value.length > 4) {
                return;
            }
        }
        setData((prevState) => ({
            ...prevState,
            [prop]: value, 
        }));
    }

    useEffect((props) => { 
        props.updateStepData('two', data)
    }, [data])



    return(
            <div style={{padding:50}}>
                <div className="px-4 sm:px-0">
                    <h3 className="text-base/7 font-semibold text-gray-900">Informacion del Vehiculo</h3>
                    <p className="mt-1 max-w-2xl text-sm/6 text-gray-500"></p>
                </div>
                <div className="mt-6 border-t border-gray-100">
                    <dl className="divide-y divide-gray-100">
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="location" className="block text-sm/6 font-medium text-gray-900">
                                        Condicion
                                    </label>
                                    <select
                                        value={data.condition}
                                        onChange={(e) => {handleChange('condition', e.target.value)}}
                                        id="location"
                                        name="location"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                    >
                                        <option value={null}>SELECCIONAR</option>
                                        <option value={'PROPIETARIO'}>PROPIETARIO</option>
                                        <option value={'PEATON'}>PEATON</option>
                                        <option value={'CONDUCTOR'}>CONDUCTOR</option>
                                        <option value={'TESTIGO'}>TESTIGO</option>
                                        <option value={'AGRAVIADO'}>AGRAVIADO</option>
                                        <option value={'OTROS'}>OTROS</option>
                                    </select>
                                </div>
                            </dd>
                            
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="location" className="block text-sm/6 font-medium text-gray-900">
                                        Tipo de vehiculo
                                    </label>
                                        <select
                                            value={data.typeVehicle}
                                            onChange={(e) => {handleChange('typeVehicle', e.target.value)}}
                                            id="location"
                                            name="location"
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        >
                                            <option value={null}>SELECCIONAR</option>
                                            {
                                                props.typeVehicles?.map((item) => {
                                                    return <option value={item.id}>{item.value}</option>
                                                })
                                            }
                                    </select>
                                </div>
                            </dd>
                            
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Placa del Vehiculo
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            value={data.plate}
                                            onChange={(e) => {handleChange('plate', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Marca
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            value={data.brand}
                                            onChange={(e) => {handleChange('brand', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Modelo
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            value={data.model}
                                            onChange={(e) => {handleChange('model', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Color
                                    </label>
                                    <div className="mt-2">
                                        <select
                                            value={data.color}
                                            onChange={(e) => {handleChange('color', e.target.value)}}
                                            id="location"
                                            name="location"
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        >
                                            <option value={null}>SELECCIONAR</option>
                                            {
                                                props.colors.map((color) => {
                                                        return(
                                                            <option key={color.id} value={color.id}>{color.value}</option>
                                                        )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Año
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            value={data.year}
                                            onChange={(e) => {handleChange('year', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Serial
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            value={data.serial}
                                            onChange={(e) => {handleChange('serial', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" style={{paddingTop:20}}>
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0" style={{display:'flex', flexDirection:'row'}}>
                                <div>
                                    <p>Requirio estacionamiento ? </p>
                                </div>
                                <div style={{marginLeft:20}}>
                                    <Switch
                                        checked={data.idParking === 1 ? true : false}
                                        onChange={(e) => {handleChange('idParking', e)}}
                                        className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                                    >
                                        <span
                                            aria-hidden="true"
                                            className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                        />
                                    </Switch>
                                </div>
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
    )
}